import { Handle, Position } from '@xyflow/react';
import { NODE_PRESENTATION } from './nodePresentationRegistry';
import { toDisplayText } from './model';

export default function CalculationNode({ data, selected }) {
  const presentation = NODE_PRESENTATION[data.nodeType] || { label: data.nodeType, description: '', icon: null };
  const definition = data.definition || { inputs: {}, outputs: {} };
  const Icon = presentation.icon;
  const inputs = Object.entries(definition.inputs || {});
  const outputs = Object.entries(definition.outputs || {});
  const portLabel = port => presentation.ports?.[port] || (port === 'result' ? 'Resultado' : port === 'value' ? 'Valor' : 'Entrada');

  return <div className={`cm-node${selected ? ' is-selected' : ''}`}>
    {inputs.map(([port, config], index) => <Handle
      key={`in-${port}`}
      id={port}
      type="target"
      position={Position.Left}
      className="cm-node-handle"
      style={{ top: `${((index + 1) / (inputs.length + 1)) * 100}%` }}
      title={`Entrada: ${portLabel(port)} · Tipo: ${config.dataType === 'number' ? 'Número' : config.dataType}`}
    />)}
    <div className="cm-node-heading">
      {Icon && <Icon size={17} aria-hidden="true" />}
      <strong>{toDisplayText(data.name, presentation.label)}</strong>
    </div>
    {!!inputs.length && <div className="cm-node-ports cm-node-ports-in">{inputs.map(([port]) => <span key={port}>{portLabel(port)}</span>)}</div>}
    {!!outputs.length && <div className="cm-node-ports cm-node-ports-out">{outputs.map(([port]) => <span key={port}>{portLabel(port)}</span>)}</div>}
    {outputs.map(([port, config], index) => <Handle
      key={`out-${port}`}
      id={port}
      type="source"
      position={Position.Right}
      className="cm-node-handle"
      style={{ top: `${((index + 1) / (outputs.length + 1)) * 100}%` }}
      title={`Salida: ${portLabel(port)} · Tipo: ${config.dataType === 'number' ? 'Número' : config.dataType}`}
    />)}
  </div>;
}
